import AppInput from '@nxsys/components/AppInput';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import { Form } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import StepCard from './StepCard';

interface AddUTRNumberProps {
  stepNumber: number;
  UTRNo?: string | null;
  completed?: boolean;
  onSubmitStep: (values: any) => void;
}

type AddUTRNumberValues = {
  utrNumberValue: string;
};

const AddUTRNumber: React.FC<AddUTRNumberProps> = ({
  stepNumber,
  UTRNo,
  completed = false,
  onSubmitStep,
}) => {
  const [form] = Form.useForm<AddUTRNumberValues>();
  const { messages } = useIntl();

  const onFinish = (values: AddUTRNumberValues) => {
    const params = {
      UTRNo: values?.utrNumberValue ?? null,
    };
    onSubmitStep(params);
  };

  return (
    <StepCard
      title={messages['prospect.onboarding.addUTRNumber'] as string}
      stepNumber={stepNumber}
      completed={completed}
      actions={[
        {
          variant: 'outlined',
          name: messages['common.save'] as string,
          onClick: () => form.submit(),
        },
      ]}
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        initialValues={{
          utrNumberValue: UTRNo ?? '',
        }}
        wrapperCol={{ span: 24 }}
        layout="vertical"
      >
        <Form.Item
          label={messages['common.UTRNumber'] as string}
          name="utrNumberValue"
          rules={[
            {
              required: true,
              message: messages['validation.UTRNumberRequired'] as string,
            },
          ]}
        >
          <AppInput
            placeholder={`${messages['form.enter'] as string} ${
              messages['common.UTRNumber'] as string
            }`}
          />
        </Form.Item>
      </AppFormContainer>
    </StepCard>
  );
};

export default AddUTRNumber;
